import { Components, Theme } from "@mui/material/styles";

export const MuiInputBase: Components<Theme>["MuiInputBase"] = {
  styleOverrides: {
    input: ({ theme }) => ({
      // Override browser autofill blue background and white text.
      // Selectors must be separate rules — comma-joined selectors with vendor pseudo-classes
      // cause browsers to silently discard states (especially the unfocused/blur state).
      // CSS variables are not used here because they may not resolve inside :-webkit-autofill.
      "&:-webkit-autofill": {
        WebkitBoxShadow: `0 0 0 100px ${theme.palette.background.paper} inset !important`,
        WebkitTextFillColor: `${theme.palette.text.primary} !important`,
        caretColor: `${theme.palette.text.primary} !important`,
      },
      "&:-webkit-autofill:hover": {
        WebkitBoxShadow: `0 0 0 100px ${theme.palette.background.paper} inset !important`,
        WebkitTextFillColor: `${theme.palette.text.primary} !important`,
        caretColor: `${theme.palette.text.primary} !important`,
      },
      "&:-webkit-autofill:focus": {
        WebkitBoxShadow: `0 0 0 100px ${theme.palette.background.paper} inset !important`,
        WebkitTextFillColor: `${theme.palette.text.primary} !important`,
        caretColor: `${theme.palette.text.primary} !important`,
      },
      "&:-webkit-autofill:active": {
        WebkitBoxShadow: `0 0 0 100px ${theme.palette.background.paper} inset !important`,
        WebkitTextFillColor: `${theme.palette.text.primary} !important`,
        caretColor: `${theme.palette.text.primary} !important`,
      },
    }),
  },
};
